

export const VisitorCounter = ({ eventType, visitors }) => {
    if (eventType === 0) {
        return (
            <div>
                <div className="d-flex">
                    <div className="me-1">Количество участников:</div>
                    <div>{visitors.length}</div>
                </div>
                <div className="d-flex">
                    <div className="me-1">На месте:</div>
                    <div>{visitors.filter(item => item.visitorStatus === 1).length}</div>
                </div>
            </div>
        )
    }
    if (eventType === 1) {
        return (
            <div className="fw-bold">
                <div className="d-flex">
                    <div className="me-1">Количество участников:</div>
                    <div>{visitors.length}</div>
                </div>
                <div className="d-flex">
                    <div className="me-1">На тест:</div>
                    <div>{visitors.filter(item => item.visitorStatus === 2).length}</div>
                </div>
                <div className="d-flex">
                    <div className="me-1">Вход разрешен:</div>
                    <div>{visitors.filter(item => item.visitorStatus === 3).length}</div>
                </div>
                <div className="d-flex">
                    <div className="me-1">Вход запрещен:</div>
                    <div>{visitors.filter(item => item.visitorStatus === 4).length}</div>
                </div>
                <div className="d-flex">
                    <div className="me-1">На месте:</div>
                    <div>{visitors.filter(item => item.visitorStatus === 1).length}</div>
                </div>
            </div>
        )
    }
    if (eventType === 2) {
        return (
            <div>
                <div className="d-flex">
                    <div className="me-1">Количество участников:</div>
                    <div>{visitors.length}</div>
                </div>
                <div className="d-flex">
                    <div className="me-1">Сдал тест:</div>
                    <div>{visitors.filter(item => item.visitorStatus === 2).length}</div>
                </div>
            </div>
        )
    }
    if (eventType === 3) {
        return (
            <div>
                <div className="d-flex">
                    <div className="me-1">Количество заказов:</div>
                    <div>{visitors.length}</div>
                </div>
                <div className="d-flex">
                    <div className="me-1">Выдано заказов:</div>
                    <div>{visitors.filter(item => item.visitorStatus === 5).length}</div>
                </div>
                <div className="d-flex">
                    <div className="me-1">На месте:</div>
                    <div>{visitors.filter(item => item.visitorStatus === 1).length}</div>
                </div>
            </div>
        )
    }
    if (eventType === 4) {
        return (
            <div className="fw-bold">
                <div className="d-flex">
                    <div className="me-1">Количество участников:</div>
                    <div>{visitors.length}</div>
                </div>
                <div className="d-flex">
                    <div className="me-1">На тест:</div>
                    <div>{visitors.filter(item => item.visitorStatus === 2).length}</div>
                </div>
                <div className="d-flex">
                    <div className="me-1">Вход разрешен:</div>
                    <div>{visitors.filter(item => item.visitorStatus === 3).length}</div>
                </div>
                <div className="d-flex">
                    <div className="me-1">Вход запрещен:</div>
                    <div>{visitors.filter(item => item.visitorStatus === 4).length}</div>
                </div>
                <div className="d-flex">
                    <div className="me-1">На месте:</div>
                    <div>{visitors.filter(item => item.visitorStatus === 1).length}</div>
                </div>
            </div>
        )
    }
    if (eventType === 5) {
        return (
            <div>
                <div className="d-flex">
                    <div className="me-1">Количество заказов:</div>
                    <div>{visitors.length}</div>
                </div>
                <div className="d-flex">
                    <div className="me-1">На месте:</div>
                    <div>{visitors.filter(item => item.visitorStatus === 1).length}</div>
                </div>
            </div>
        )
    }
    if (eventType === 6) {
        return (
            <div className="fw-bold">
                <div className="d-flex">
                    <div className="me-1">Количество участников:</div>
                    <div>{visitors.length}</div>
                </div>
                <div className="d-flex">
                    <div className="me-1">На тест:</div>
                    <div>{visitors.filter(item => item.visitorStatus === 2).length}</div>
                </div>
                <div className="d-flex">
                    <div className="me-1">Вход разрешен:</div>
                    <div>{visitors.filter(item => item.visitorStatus === 3).length}</div>
                </div>
                <div className="d-flex">
                    <div className="me-1">Вход запрещен:</div>
                    <div>{visitors.filter(item => item.visitorStatus === 4).length}</div>
                </div>
                <div className="d-flex">
                    <div className="me-1">На месте:</div>
                    <div>{visitors.filter(item => item.visitorStatus === 1).length}</div>
                </div>
            </div>
        )
    }
    if (eventType === 7) {
        return (
            <div>
                <div className="d-flex">
                    <div className="me-1">Количество участников:</div>
                    <div>{visitors.length}</div>
                </div>
                <div className="d-flex">
                    <div className="me-1">На месте:</div>
                    <div>{visitors.filter(item => item.visitorStatus === 1).length}</div>
                </div>
            </div>
        )
    }
}